import api from '../../apiConfig/apiConfig'
import { Get, Post, Patch } from '../base/baseAjax'

// 网站下拉列表
let getpulldownlist = id => {
  return Get({
    url: api.seo.getpulldownlist + `?customerId=${id}`
  })
}

// 添加seo网站
let addseoweb = param => {
  return Post({
    url: api.seo.addseoweb,
    bodyParam: param
  })
}

// 看板分页列表
let getboardlist = param => {
  return Post({
    url: api.seo.getboardlist,
    bodyParam: param
  })
}

// seo网站详情
let getwebsitedetail = id => {
  return Get({
    url: api.seo.getwebsitedetail + id
  })
}
// seo网站修改
let setwebsiteup = (id, param) => {
  return Patch({
    url: api.seo.setwebsiteup + id,
    bodyParam: param
  })
}
// 关键词统计
let keywordstati = id => {
  return Get({
    url: api.seo.keywordstati + `?seoSiteId=${id}`
  })
}
// seo文章详情
let seoarticledetail = id => {
  return Get({
    url: api.seo.seoarticledetail + id
  })
}
// 文章是否使用
let articleuseswitch = param => {
  return Post({
    url: api.seo.articleuseswitch,
    bodyParam: param
  })
}
// 文章设为有效
let setarticlevalid = param => {
  return Post({
    url: api.seo.setarticlevalid,
    bodyParam: param,
    config: {
      timeout: 30000
    }
  })
}
// 添加优化
let addoptimize = param => {
  return Post({
    url: api.seo.addoptimize,
    bodyParam: param
  })
}
// 删除优化
let deloptimize = ids => {
  return Patch({
    url: api.seo.deloptimize,
    bodyParam: ids
  })
}
// 编辑标题
let compiletitle = param => {
  return Post({
    url: api.seo.compiletitle,
    bodyParam: param
  })
}
// 保存文章
let savearticle = param => {
  return Post({
    url: api.seo.savearticle,
    bodyParam: param
  })
}

// 文章翻译
let translation = param => {
  return Get({
    url: api.seo.translation + param
  })
}

// 关键字报告
let keywordReport = param => {
  return Post({
    url: api.seo.keywordReport,
    bodyParam: param,
    config: {
      timeout: 60000
    }
  })
}

let queryGeotargets = param => {
  return Get({
    url: api.seo.queryGeotargets,
    PathParam: param
  })
}

let languageList = () => {
  return Get({
    url: api.seo.languageList
  })
}
export default {
  getpulldownlist,
  addseoweb,
  getboardlist,
  getwebsitedetail,
  setwebsiteup,
  keywordstati,
  seoarticledetail,
  articleuseswitch,
  setarticlevalid,
  addoptimize,
  deloptimize,
  compiletitle,
  savearticle,
  translation,
  languageList,
  queryGeotargets,
  keywordReport
}
